"use strict";
/**
 * NOTE: This component will inject the Google Maps API if not already loaded.
 * `<script type="text/javascript" src="https://maps.google.com/maps/api/js?v=VERSION&key=API_KEY&libraries=places"></script>`
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMap = void 0;
var React = require("react");
var ReactDOMServer = require("react-dom/server");
// @ts-ignore
var MarkerClusterer = require("@google/markerclustererplus");
var utility_1 = require("../utility");
var GoogleMap = /** @class */ (function (_super) {
    __extends(GoogleMap, _super);
    function GoogleMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.googleMapElement = React.createRef();
        _this.state = {
            googleMap: null,
            googleCluster: null,
            googleInfoWindow: null,
        };
        _this.toggleCluster = function (enabled) {
            if (enabled === void 0) { enabled = true; }
            _this.state.googleCluster.setGridSize(enabled ? 60 : 0);
        };
        _this.createMarker = function (marker) {
            var gmarker = new google.maps.Marker({
                id: marker.id,
                icon: marker.icon,
                position: marker.position,
            });
            if (_this.props.markersOnClick) {
                gmarker.addListener("click", function () { return _this.props.markersOnClick(marker); });
            }
            if (_this.props.markersOnHover) {
                gmarker.addListener("hover", function () { return _this.props.markersOnHover(marker); });
            }
            return gmarker;
        };
        _this.markersAdd = function (markers) {
            _this.state.googleCluster.addMarkers(markers.map(function (marker) { return _this.createMarker(marker); }));
        };
        _this.markersRemove = function (markerIds) {
            var gmarkers = _this.state.googleCluster.getMarkers().filter(function (gmarker) { return markerIds.includes(gmarker.id); });
            _this.state.googleCluster.removeMarkers(gmarkers);
        };
        _this.markersClear = function () {
            _this.state.googleCluster.clearMarkers();
        };
        _this.compareMarkers = function (markerA, markerB) {
            var markerALat;
            var markerALng;
            var markerBLat;
            var markerBLng;
            if (typeof markerA.position.lat === "function" && typeof markerA.position.lng === "function") {
                markerALat = markerA.position.lat();
                markerALng = markerA.position.lng();
            }
            else {
                markerALat = markerA.position.lat;
                markerALng = markerA.position.lng;
            }
            if (typeof markerB.position.lat === "function" && typeof markerB.position.lng === "function") {
                markerBLat = markerB.position.lat();
                markerBLng = markerB.position.lng();
            }
            else {
                markerBLat = markerB.position.lat;
                markerBLng = markerB.position.lng;
            }
            var matchId = markerA.id === markerB.id;
            var matchLat = markerALat.toFixed(6) === markerBLat.toFixed(6);
            var matchLng = markerALng.toFixed(6) === markerBLng.toFixed(6);
            return matchId && matchLat && matchLng;
        };
        _this.markerAdd = function (marker) {
            _this.state.googleCluster.addMarker(_this.createMarker(marker), true);
        };
        _this.markerRemove = function (markerId) {
            var gmarker = _this.state.googleCluster.getMarkers().find(function (gmarker) { return gmarker.id === markerId; });
            _this.state.googleCluster.removeMarker(gmarker);
        };
        /** Uses [[GoogleMap.infowindowClose]] method before calling Google Infowindow `open()` method */
        _this.infowindowOpen = function (marker) { return __awaiter(_this, void 0, void 0, function () {
            var googleInfoWindow_1, gmarker;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.infowindowClose();
                        if (!!this.state.googleInfoWindow) return [3 /*break*/, 2];
                        googleInfoWindow_1 = new google.maps.InfoWindow({
                            maxWidth: this.props.infowindowMaxWidth,
                        });
                        google.maps.event.addListener(googleInfoWindow_1, "closeclick", function () { return _this.props.infowindowOnClose(); });
                        return [4 /*yield*/, new Promise(function (resolve) { return _this.setState({ googleInfoWindow: googleInfoWindow_1 }, function () { return resolve(); }); })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.state.googleInfoWindow.setContent(ReactDOMServer.renderToStaticMarkup(this.props.infowindowContent(marker)));
                        gmarker = this.state.googleCluster.getMarkers().find(function (gmarker) { return gmarker.id === marker.id; });
                        this.state.googleInfoWindow.open(this.state.googleMap, gmarker);
                        return [2 /*return*/];
                }
            });
        }); };
        /** Uses Google Infowindow `close()` method */
        _this.infowindowClose = function () {
            if (_this.state.googleInfoWindow) {
                _this.state.googleInfoWindow.close();
            }
        };
        /** Uses Google Map `panTo()` method */
        _this.mapPanTo = function (position) {
            return new Promise(function (resolve) {
                _this.state.googleMap.panTo(position);
                google.maps.event.addListenerOnce(_this.state.googleMap, "idle", function () {
                    _this.state.googleCluster.repaint();
                    resolve();
                });
            });
        };
        /** Uses Google Map `getZoom()` a no-op check and then `setZoom()` method */
        _this.mapZoomTo = function (zoom) {
            return new Promise(function (resolve) {
                if (_this.state.googleMap.getZoom() === zoom) {
                    return resolve();
                }
                else {
                    _this.state.googleMap.setZoom(zoom);
                    google.maps.event.addListenerOnce(_this.state.googleMap, "idle", function () {
                        _this.state.googleCluster.repaint();
                        resolve();
                    });
                }
            });
        };
        /** Uses Google LatLngBounds `extend()` method before calling Google Map `fitBounds()` method */
        _this.mapFitMarkers = function (markers) {
            if (markers === void 0) { markers = _this.state.googleCluster.markers_; }
            if (!markers.length) {
                return;
            }
            return new Promise(function (resolve) {
                var bounds = new google.maps.LatLngBounds();
                for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
                    var marker = markers_1[_i];
                    bounds.extend(marker.position);
                }
                _this.state.googleMap.fitBounds(bounds);
                google.maps.event.addListenerOnce(_this.state.googleMap, "idle", function () {
                    _this.state.googleCluster.repaint();
                    resolve();
                });
            });
        };
        /** Uses Google Map `getBounds()` method */
        _this.mapGetBounds = function () {
            var bounds = _this.state.googleMap.getBounds();
            var northEast = bounds.getNorthEast();
            var southWest = bounds.getSouthWest();
            var northEastLat = northEast.lat();
            var northEastLng = northEast.lng();
            var southWestLat = southWest.lat();
            var southWestLng = southWest.lng();
            return {
                tr: { lat: northEastLat, lng: northEastLng },
                bl: { lat: southWestLat, lng: southWestLng },
                tl: { lat: northEastLat, lng: southWestLng },
                br: { lat: southWestLat, lng: northEastLng },
            };
        };
        /** Uses Google Map `getCenter()` method */
        _this.mapGetCenter = function () {
            var center = _this.state.googleMap.getCenter();
            return {
                lat: center.lat(),
                lng: center.lng(),
            };
        };
        _this.mapGetZoom = function () {
            return _this.state.googleMap.getZoom();
        };
        _this.mapPanToAndFitMarkers = function (position) {
            _this.markersClear();
            return _this.mapPanTo(position)
                .then(function () { return _this.mapFitMarkers(); });
        };
        return _this;
    }
    GoogleMap.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var googleMap, googleCluster;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!window.hasOwnProperty("google")) return [3 /*break*/, 2];
                        if (!this.props.googleMapsApiVersion || !this.props.googleMapsApiKey) {
                            throw new Error("Google Maps API has not been pre-loaded and no Version or API Key has been provided.");
                        }
                        return [4 /*yield*/, utility_1.InjectScript("https://maps.google.com/maps/api/js?v=" + this.props.googleMapsApiVersion + "&key=" + this.props.googleMapsApiKey + "&libraries=places")];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        googleMap = new google.maps.Map(this.googleMapElement.current, __assign({}, this.props.googleMapsOptions));
                        if (this.props.mapOnFirstIdle) {
                            google.maps.event.addListenerOnce(googleMap, "idle", function () { return _this.props.mapOnFirstIdle(_this.mapGetBounds()); });
                        }
                        googleCluster = new MarkerClusterer(googleMap, [], __assign(__assign({}, this.props.clusterOptions), { zoomOnClick: false }));
                        googleCluster.addListener("click", function (event) { return _this.mapFitMarkers(event.markers_); });
                        if (this.props.mapOnDragStart) {
                            google.maps.event.addListener(googleMap, "dragstart", function () { return _this.props.mapOnDragStart(_this.mapGetBounds()); });
                        }
                        if (this.props.mapOnDragEnd) {
                            google.maps.event.addListener(googleMap, "dragend", function () { return _this.props.mapOnDragEnd(_this.mapGetBounds()); });
                        }
                        if (this.props.mapOnBoundsChange) {
                            google.maps.event.addListener(googleMap, "bounds_changed", function () {
                                if (_this.mapGetZoom() === _this.props.googleMapsOptions.maxZoom) {
                                    _this.toggleCluster(false);
                                }
                                else {
                                    _this.toggleCluster(true);
                                }
                                _this.props.mapOnBoundsChange(_this.mapGetBounds());
                            });
                        }
                        if (this.props.mapOnZoomChange) {
                            google.maps.event.addListener(googleMap, "zoom_changed", function () { return _this.props.mapOnZoomChange(_this.mapGetBounds()); });
                        }
                        if (this.props.mapOnPanChange) {
                            google.maps.event.addListener(googleMap, "pan_changed", function () { return _this.props.mapOnPanChange(_this.mapGetBounds()); });
                        }
                        if (this.props.mapOnClick) {
                            google.maps.event.addListener(googleMap, "click", function (event) { return _this.props.mapOnClick(event); });
                        }
                        this.setState({
                            googleMap: googleMap,
                            googleCluster: googleCluster,
                        }, function () { return _this.props.callback && _this.props.callback(_this); });
                        return [2 /*return*/];
                }
            });
        });
    };
    GoogleMap.prototype.componentDidUpdate = function () {
        this.markersSync();
    };
    GoogleMap.prototype.markersSync = function () {
        var _this = this;
        // Find markers that exist in `googleCluster` but not in `props`
        var markersToRemove = this.state.googleCluster.getMarkers().filter(function (gmarker) { return !_this.props.markers.find(function (marker) {
            return _this.compareMarkers(marker, gmarker);
        }); }).map(function (m) { return m.id; });
        this.markersRemove(markersToRemove);
        // Find markers that exist in `props` but not in `googleCluster`
        var markersToAdd = this.props.markers.filter(function (marker) { return !_this.state.googleCluster.getMarkers().find(function (gmarker) { return gmarker.id === marker.id; }); });
        this.markersAdd(markersToAdd);
    };
    GoogleMap.prototype.render = function () {
        return (React.createElement("div", { ref: this.googleMapElement, className: this.props.className, style: this.props.style }));
    };
    return GoogleMap;
}(React.Component));
exports.GoogleMap = GoogleMap;
//# sourceMappingURL=google-map.js.map